import {
  Article,
  ArticleCategories,
  ArticlePreview,
} from "../interfaces/sanity/sanityClasses";

/**
 * Returns the name of the first category of the article.
 * @returns {string} The name of the first category of the article.
 */
export const getArticleCategory = (article: any) => {
  if (article.categories && article.categories.length > 0) {
    return article.categories[0].title;
  }
  return "-";
};

/**
 * Returns all categories of the articles.
 * @param articles The articles to get the categories from.
 * @returns {ArticleCategories[]} All categories of the articles.
 */
export const getAllCategories = (articles: Article[] | ArticlePreview[]) =>
  articles.reduce((acc: ArticleCategories[], article) => {
    article.categories.forEach((category) => {
      if (!acc.some((accCategory) => accCategory.id === category.id)) {
        acc.push(category);
      }
    });
    return acc;
  }, []);

/**
 * Returns true if the article has the category with the given id.
 * @param article The article to check.
 * @param id The id of the category to check for.
 * @returns {boolean} True if the article has the category with the given id.
 */
export const articleHasCategory = (
  article: Article | ArticlePreview,
  id: string | null
) => article.categories.find((category) => category.id === id);
